import { render, staticRenderFns } from "./createAnnualBudget.vue?vue&type=template&id=2bd1c28a&"
import script from "./createAnnualBudget.vue?vue&type=script&lang=js&"
export * from "./createAnnualBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports